
export const apiBase = '/api'
export const getJwt = () => window.localStorage.getItem('jwt')
export const setJwt = jwt => window.localStorage.setItem('jwt', jwt)
export const getTestConference = () => window.localStorage.getItem('conference')
export const setTestConference = conference => window.localStorage.setItem('conference', conference)
export const deleteTestConference = conference => window.localStorage.removeItem('conference')
